import { render, staticRenderFns } from "./SQuesFour.vue?vue&type=template&id=6de418b9&scoped=true&"
import script from "./SQuesFour.vue?vue&type=script&lang=js&"
export * from "./SQuesFour.vue?vue&type=script&lang=js&"
import style0 from "./SQuesFour.vue?vue&type=style&index=0&id=6de418b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de418b9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
